export default {
  Categories: {
    ProductsInput: {
      Title: 'افزودن ورودی های محصولات دسته بندی',
    },
  },
}
